import { createFileRoute } from '@tanstack/react-router';

import {
  MediaPlanPage,
  mediaPlansSearchParamsSchema,
} from '@/features/mediaPlan';

export const Route = createFileRoute('/_app/media-plans')({
  validateSearch: mediaPlansSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <MediaPlanPage />;
}
